import { render, staticRenderFns } from "./headlimit.vue?vue&type=template&id=f51d7f98&"
import script from "./headlimit.vue?vue&type=script&lang=js&"
export * from "./headlimit.vue?vue&type=script&lang=js&"
import style0 from "./headlimit.vue?vue&type=style&index=0&id=f51d7f98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports